import React from 'react';
import { Box, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { monthNames } from '../../../utils/settings';

const styles = {
  dateContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
    alignItems: 'flex-end'
  }
};

const DateSelector = ({ dateValue, onDateChange, label, required = false, optional = false }) => (
  <>
    <Typography variant="subtitle1" gutterBottom>
      {label} {required && <span style={{ color: 'red' }}>*</span>}
      {optional && <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>(Opsiyonel)</Typography>}
    </Typography>
    <Box sx={styles.dateContainer}>
      <TextField
        label="Gün"
        type="number"
        name="day"
        value={dateValue?.day || ''}
        onChange={onDateChange}
        inputProps={{ min: 1, max: 31 }}
        style={{ width: '80px' }}
        required={required}
        error={required && !dateValue?.day}
      />
      <FormControl style={{ minWidth: '120px' }} required={required} error={required && (dateValue?.month === '' || dateValue?.month === undefined)}>
        <InputLabel>Ay</InputLabel>
        <Select
          name="month"
          value={dateValue?.month !== undefined ? dateValue.month : ''}
          onChange={onDateChange}
          label="Ay"
        >
          {monthNames.map((month, index) => (
            <MenuItem key={index} value={index}>{month}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Yıl"
        type="number"
        name="year"
        value={dateValue?.year || ''}
        onChange={onDateChange}
        style={{ width: '100px' }}
        required={required}
        error={required && !dateValue?.year}
      />
      <FormControlLabel
        control={
          <Checkbox
            name="isBC"
            checked={dateValue?.isBC || false}
            onChange={onDateChange}
          />
        }
        label="MÖ"
      />
    </Box>
  </>
);

export default DateSelector;